import React from 'react';
import ServiceCard from './ServiceCard';
import { Helmet } from 'react-helmet';
import '@fortawesome/fontawesome-free/css/all.min.css';


const servicesData = [
  {
    icon: "fa fa-car",
    title: "Parking",
    services: [
      "Adequate parking facilities have been thoughtfully provided to ensure the utmost convenience for our residents, addressing their parking needs seamlessly."
    ],
    delay: 0
  },
  {
    icon: "fa fa-wifi",
    title: "Free Wifi",
    services: [
      "In this fast-paced digital age, connectivity is key, and Om Sai PG is committed to providing residents with a seamless online experience through free WiFi services."
    ],
    delay: 200
  },
  {
    icon:  "fa fa-snowflake",
    title: "Refrigerator",
    services: [
      "Each room is thoughtfully equipped with a refrigerator, adding a touch of convenience to residents' stays by providing a handy space for storing and preserving their essentials."
    ],
    delay: 400
  },
  {
    icon: "fa fa-archive",
    title: "Almirah",
    services: [
      "In every room, residents benefit from the availability of spacious almirahs, ensuring organized and efficient storage solutions to enhance their living experience."
    ],
    delay: 600
  },
  {
    icon: "fa fa-bath", 
    title: "Washroom",
    services: [
      "Residents benefit from conveniently accessible and well-maintained washrooms, reflecting our commitment to ensuring their comfort and satisfaction with the overall living."
    ],
    delay: 0
  },
  {
    icon: "fa fa-camera-retro",
    title: "CCTV Camera",
    services: [
      "Prioritizing the safety of our residents, key areas are equipped with CCTV cameras, underscoring our commitment to maintaining a secure and protected living environment."
    ],
    delay: 200
  },
  {
    icon:  "fa fa-tshirt",
    title: "Laundry Service",
    services: [
      "Convenient laundry service for your clothes, ensuring they stay fresh and clean during your stay."
    ],
    delay: 400
  },
  {
    icon: "fa fa-mug-hot", // Represents a coffee mug for breakfast
    title: "Breakfast",
    services: [
      "Start your day with a delightful breakfast offering a variety of options to energize you for the day ahead."
    ],
    delay: 400
  }
];

const ServicesSection = () => {
  return (
  <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/images/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 | Om Sai PG|Boys Hostel in Kharadi | Monthly Basis PG in Kharadi | PG in Wagholi | PG in Kharadi With Food
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="PG in Pune, PG in Kharadi, PG with food in Pune, Boys Hostel in Kharadi, Monthly Basis PG in Kharadi,PG in Wagholi,PG in Kharadi With Food"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

  
    <section className="section-services padding-tb-50">
      <div className="container">
        <div className="row mb-minus-24">
          <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img src="img/banner/left-shape.svg" alt="banner-left-shape" className="svg-img left-side" />
                Facilities
                <img src="img/banner/right-shape.svg" alt="banner-right-shape" className="svg-img right-side" />
              </p>
              <h4>Our Best <span>Services</span></h4>
            </div>
          </div>

          {servicesData.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              services={service.services}
              delay={service.delay}
            />
          ))}
        </div>
      </div>
    </section>
    </>
  );
};

export default ServicesSection;
